import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CANADA_POSTAL_CODE_FIRST_LETTERS_BY_STATE_CODE } from '../consts/canada-postal-code-prefixes';

const CANADA_POSTAL_CODE_LENGTH = 7;
const CANADA_POSTAL_CODE_PATTERN = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;

const INVALID_POSTAL_CODE: ValidationErrors = { invalidPostalCode: true };

function readValue(control: AbstractControl): string | null {
  return typeof control.value === 'string' && control.value.length > 0 ? control.value : null;
}

export function canadaPostalCodeLengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = readValue(control);
    if (value === null) {
      return null;
    }
    return value.length === CANADA_POSTAL_CODE_LENGTH ? null : INVALID_POSTAL_CODE;
  };
}

export function canadaPostalCodeFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = readValue(control);
    if (value === null) {
      return null;
    }
    return CANADA_POSTAL_CODE_PATTERN.test(value) ? null : INVALID_POSTAL_CODE;
  };
}

export function canadaPostalCodeProvinceValidator(stateCode: string | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = readValue(control);
    const allowedFirstLetters = stateCode ? CANADA_POSTAL_CODE_FIRST_LETTERS_BY_STATE_CODE[stateCode] : null;
    if (value === null || !allowedFirstLetters) {
      return null;
    }
    return allowedFirstLetters.includes(value.charAt(0).toUpperCase()) ? null : INVALID_POSTAL_CODE;
  };
}
